import PropTypes from "prop-types";
import Modal from "../Modal";
import orderSuccessGIF from "../../../../assets/gifs/order_success.gif";
import classes from "./OrderSuccessModal.module.css";

const OrderSuccessModal = (props) => {
  const { isOpen, onClose, message } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={classes["order-success-modal"]}>
        <img
          src={orderSuccessGIF}
          alt="success"
          className={classes["order-success-modal__success-gif"]}
        />
        <p className={classes["order-success-modal__thanks-text"]}>شكرا !</p>
        <h2 className={classes["order-success-modal__header"]}>{message}</h2>
        <p className={classes["order-success-modal__contact-text"]}>
          سيتم التواصل معك في خلال
          <br />
          دقائق لتأكيد طلبك
        </p>
      </div>
    </Modal>
  );
};

export default OrderSuccessModal;

OrderSuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  message: PropTypes.string,
};
